package com.castly.admin.ui.analytics

import androidx.compose.runtime.Composable
import com.castly.admin.ui.theme.*
import com.castly.shared.dto.TimeSeriesPoint
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun SimpleBarChart(
    data: List<TimeSeriesPoint>,
    title: String,
    barColor: String? = null
) {
    val colors = AppTheme.colors
    val color = barColor ?: colors.primary
    val maxVal = data.maxOfOrNull { it.value } ?: 1L

    Div({
        style {
            cardStyle(colors)
        }
    }) {
        H3({
            style {
                margin(0.px)
                marginBottom(Spacing.lg)
                fontSize(Typography.lg)
                color(Color(colors.text))
                fontWeight("600")
            }
        }) { Text(title) }

        if (data.isEmpty()) {
            Div({
                style {
                    padding(Spacing.xxl)
                    textAlign("center")
                    color(Color(colors.textMuted))
                    fontSize(Typography.sm)
                }
            }) { Text("No data available") }
        } else {
            Div({
                style {
                    display(DisplayStyle.Flex)
                    alignItems(AlignItems.FlexEnd)
                    gap(2.px)
                    height(160.px)
                    paddingBottom(Spacing.xxl)
                    position(Position.Relative)
                }
            }) {
                data.forEach { point ->
                    val heightPct = if (maxVal > 0) (point.value.toDouble() / maxVal * 100).toInt() else 0
                    Div({
                        style {
                            property("flex", "1")
                            display(DisplayStyle.Flex)
                            flexDirection(FlexDirection.Column)
                            alignItems(AlignItems.Center)
                            justifyContent(JustifyContent.FlexEnd)
                            height(100.percent)
                            position(Position.Relative)
                        }
                        title("${point.date}: ${point.value}")
                    }) {
                        Div({
                            style {
                                width(100.percent)
                                maxWidth(20.px)
                                height(heightPct.percent)
                                minHeight(if (point.value > 0) 2.px else 0.px)
                                backgroundColor(Color(color))
                                borderRadius(2.px, 2.px, 0.px, 0.px)
                                property("transition", "height 0.3s ease")
                            }
                        })
                    }
                }
            }

            Div({
                style {
                    display(DisplayStyle.Flex)
                    justifyContent(JustifyContent.SpaceBetween)
                    fontSize(Typography.xs)
                    color(Color(colors.textMuted))
                }
            }) {
                if (data.isNotEmpty()) {
                    Span { Text(formatDateLabel(data.first().date)) }
                    Span { Text(formatDateLabel(data.last().date)) }
                }
            }
        }
    }
}

private fun formatDateLabel(date: String): String {
    val parts = date.split("-")
    return if (parts.size >= 3) "${parts[1]}/${parts[2]}" else date
}
